var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRingplanMeet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social / ringplan_meet",
    clipPath: "url(#clip0_2129_3102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 11.508V4.49198C0 1.18507 3.40292 -0.985431 6.33608 0.45071L13.5009 3.95873C16.833 5.59017 16.833 10.4097 13.5009 12.0413L6.33608 15.5493C3.40292 16.9854 0 14.8149 0 11.508Z",
    fill: "#6FC316"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 4.59909C10.6667 4.08411 10.2509 3.6665 9.73814 3.6665C9.22539 3.6665 8.8096 4.08411 8.8096 4.59909C8.8096 5.11407 9.22539 5.53168 9.73814 5.53168C10.2509 5.53168 10.6667 5.11407 10.6667 4.59909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5456 6.24885H9.0458V11.6665H10.5456V6.24885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71372 9.40231L6.19399 11.6664H7.97001L6.28269 9.13968C7.16091 8.80609 7.76295 8.08852 7.76295 6.94644V6.92617C7.76295 6.25914 7.55559 5.7033 7.17069 5.30904C6.71683 4.84398 6.03587 4.59133 5.15765 4.59133H2V11.6664H3.51987V9.40231H4.71372ZM5.0295 5.99635C5.76964 5.99635 6.22366 6.33993 6.22366 7.00696V7.02723C6.22366 7.62346 5.79915 8.02786 5.05917 8.02786H3.51987V5.99635H5.0295Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2129_3102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingplanMeet);
export default __webpack_public_path__ + "static/media/ringplan_meet.aa48d43790a0f87d0a35b27d6eff5321.svg";
export { ForwardRef as ReactComponent };